import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { RouteEngagementTypes } from "./RouteEngagementTypes";
import {
  ENGAGEMENT_TYPES_DETAILS_PATH,
  ENGAGEMENT_TYPES_SECTION_PATHS
} from "../paths";
import { RouteEngagementTypeDetails } from "./RouteEngagementTypeDetails";

export const RouteIndexEngagementTypes: React.FC = () => {
  return (
    <Switch>
      <Route
        path={ENGAGEMENT_TYPES_SECTION_PATHS}
        component={RouteEngagementTypes}
      />

      <Route
        path={ENGAGEMENT_TYPES_DETAILS_PATH}
        component={RouteEngagementTypeDetails}
      />

      <Redirect from="*" to={ENGAGEMENT_TYPES_SECTION_PATHS[0]} />
    </Switch>
  );
};
